import { LocationType } from 'src/interfaces/location';

export const LOCATION_TYPE_SHAPE: LocationType = 'location_shape';
export const LOCATION_TYPE_CLUSTER: LocationType = 'cluster';
